import clsx from 'clsx';
import Txt from 'components/atoms/Txt/Txt';
import React from 'react';
import classes from './RadioGroup.module.scss';

export interface Props {
  children: React.ReactNode;
  className?: string;
  label?: string;
  labelClassName?: string;
}

const RadioGroup: React.FC<Props> = ({ children, label, labelClassName, className }) => {
  return (
    <div className={clsx(classes.root, className)}>
      {label && <Txt className={clsx(labelClassName)}>{label}</Txt>}
      {children}
    </div>
  );
};

export default RadioGroup;
